import React from "react";
import Caption from "./Typography/Caption";
import TextField from "./TextField";

type classesType = {
  container?: string;
  caption?: string;
  textField?: string;
};

type errorType = {
  message?: string;
  code?: string | number;
};

type TextFieldWithLabelProps = {
  id: string;
  label: string | React.ReactElement;
  value: string;
  onChange: any;
  error?: errorType;
  classes?: classesType;
  textFieldProps?: any;
};
const TextFieldWithLabel: React.FC<TextFieldWithLabelProps> = ({
  id,
  label,
  value,
  onChange,
  error = {},
  classes = {},
  textFieldProps,
}): React.ReactElement => {
  return (
    <div
      className={`flex w-full flex-col pb-4 ${
        classes.container ? classes.container : ""
      }`}
    >
      <Caption classes={`mb-2 ${classes.caption}`}>{label}</Caption>
      <TextField
        value={value}
        full
        classes={`border rounded ${classes.textField}`}
        id={id}
        onChange={onChange}
        {...textFieldProps}
      />
      {error.code ? `${error.code} : ${error.message}` : ""}
    </div>
  );
};

export default TextFieldWithLabel;
